// Dropzone stuff
export default {
  computed: {
    timecardDocs() {
      return this.assets.filter(({ type }) => type === 'tcdoc');
    },
  },

  methods: {
    getAssets(object) {
      // Don't allow employees to see starts
      if (this.type === 'employee' && ! this.timecard_id) return undefined;

      let data = {
        type: object.type,
        timecardId: object.timecardId,
        assignmentId: object.assignmentId,
        employeeId: object.employeeId,
      };

      this.oasisApi.post('/assets/get/' + data.type, data)
        .then(response => {
          if (response.status == 200) {
            this.assets = response.data;
          }
        })
        .catch(error => {
          console.log('error: '); console.log(error);
        })
        ;
    },

    dzSuccess(value) {
      this.getAssets( { type: 'timecard', timecardId: this.timecard_id || null, assignmentId: this.assignment.id, employeeId: this.assignment.employee_id });
    },

    dzSave(value) {
      this.documentModal = false;
      this.loanoutDocModal = false;
      this.i9DocModal = false;
      this.timecardDocModal = false;
    },

    dzRemove(hash, type, assignmentId, employeeId, timecardId) {
      this.oasisApi.get('/assets/delete/' + hash)
        .then(response => {
          if (response.status == 200 && type) {
            let data = {
                type: type,
                assignmentId: assignmentId,
                employeeId: employeeId,
                timecardId: timecardId,
            };
            this.getAssets(data);
          }
        })
        .catch(error => {
          console.log('error: '); console.log(error);
        })
        ;
    },

    dzApprove(value) {
      this.paperFormModal = false;
      location.reload();
    },
  },
}
